<template>
    <div v-if="apenafsInConvention && apenafsInConvention.length > 0" class="activities">
        <div class="see-more-icon">
            <v-tooltip right>
                <template #activator="{ on }">
                    <v-icon small v-on="on" color="black" @click="displayDetailedApenafs">
                        mdi-arrow-expand
                    </v-icon>
                </template>
                <typo name="body-12-light"> Voir plus </typo>
            </v-tooltip>
        </div>
        <typo
            v-for="apenaf in apenafsInConvention.slice(0, numberOfDisplayedApenafs)"
            :key="apenaf._uid"
            name="body-14-normal"
        >
            {{ apenaf.code }}
        </typo>
        <typo
            v-if="numberOfMoreApenafs > 0"
            class="see-more-link"
            name="body-14-normal link"
            @click="displayDetailedApenafs"
        >
            + {{ numberOfMoreApenafs }} Autres
        </typo>
        <panorama-activities-codes-see-more
            :apenafsByCode="apenafsByCode"
            :apenafsInConvention="apenafsInConvention"
            :variantId="convention.variantId"
        />
    </div>
</template>

<script>
import { flatten, isEmpty, sortBy, uniqBy } from "lodash";
import { EventBus } from "src/bus/eventBus";
import PanoramaActivitiesCodesSeeMore from "./PanoramaActivitiesCodesSeeMore.vue";

export default {
    components: { PanoramaActivitiesCodesSeeMore },
    props: ["convention", "apenafsByCode"],
    data() {
        return {
            numberOfDisplayedApenafs: 5,
        };
    },
    methods: {
        displayDetailedApenafs() {
            EventBus.$emit(`displayAllApenafs-${this.convention.variantId}`, true);
        },
    },
    computed: {
        apenafsInConvention() {
            const filteredActivities = this.convention.activities
                .map(activity => {
                    if (activity.type !== "group") return null;
                    activity.items = activity.items.filter(item => this.apenafsByCode[item.code]);
                    return activity;
                })
                .filter(item => item !== null);
            const displayedApenafs = flatten(
                isEmpty(filteredActivities)
                    ? this.convention.activities
                          .filter(activity => activity.type !== "group")
                          .map(activity => activity.items.map(item => item))
                    : filteredActivities.map(activity => activity.items.map(item => item))
            );
            return uniqBy(sortBy(displayedApenafs, "code"), "code");
        },
        numberOfMoreApenafs() {
            return this.apenafsInConvention.length - this.numberOfDisplayedApenafs;
        },
    },
};
</script>

<style scoped lang="sass">
.activities
    display: flex
    flex-direction: column
    align-items: center
    margin: 10px 30px
    position: relative

.see-more-icon
    position: absolute
    top: -5px
    right: 50px

.see-more-link
    color: $color-main
</style>
